var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Slider } from '../Slider/index.js';
import { FormControlLayout } from './FormControlLayout.js';
import { extractLayoutProps } from './utils.js';
export const FormControlSlider = (_a) => {
    var { value } = _a, rest = __rest(_a, ["value"]);
    const { layoutProps, inputProps } = extractLayoutProps(rest);
    return (React.createElement(FormControlLayout, Object.assign({}, layoutProps, { tertiaryLabel: React.createElement("div", { className: "font-mediums text-md text-content-subdued" }, value) }),
        React.createElement(Slider, Object.assign({ value: value }, inputProps))));
};
//# sourceMappingURL=FormControlSlider.js.map